export const BUDGET = {
    container: 'budget-container',
    emptyState: 'budget-empty-state',
    currencySelect: 'budget-currency-select',
    setCurrencyButton: 'budget-set-currency-button',
    personalForm: 'budget-personal-form',
    personalEdit: 'budget-personal-edit-button',
    totalInput: 'budget-total-input',
    accommodationInput: 'budget-accommodation-input',
    foodInput: 'budget-food-input',
    transportInput: 'budget-transport-input',
    activitiesInput: 'budget-activities-input',
    notesInput: 'budget-notes-input',
    submitButton: 'budget-submit-button',
    alignmentCard: 'budget-alignment-card',
    mismatchItem: 'budget-mismatch-item',
    breakdownLocked: 'budget-breakdown-locked',
    breakdownCard: 'budget-breakdown-card',
    sharedEstimateLocked: 'budget-shared-locked',
    sharedEstimateCard: 'budget-shared-estimate-card',
    upgradeCta: 'budget-upgrade-cta',
};

export const SHARED_EXPENSES = {
    container: 'shared-expenses-container',
    addButton: 'shared-expenses-add-button',
    emptyState: 'shared-expenses-empty-state',
    form: 'shared-expense-form',
    descriptionInput: 'shared-expense-description-input',
    amountInput: 'shared-expense-amount-input',
    splitInput: 'shared-expense-split-input',
    perPersonOutput: 'shared-expense-per-person-output',
    paidBySelect: 'shared-expense-paid-by-select',
    submitButton: 'shared-expense-submit-button',
    cancelButton: 'shared-expense-cancel-button',
    item: 'shared-expense-item',
    itemPaidBy: 'shared-expense-item-paid-by',
    itemSplitTypeBadge: 'shared-expense-item-split-type-badge',
    splitTypeToggle: 'shared-expense-split-type-toggle',
    splitTypeEqual: 'shared-expense-split-type-equal',
    splitTypeCustom: 'shared-expense-split-type-custom',
    customAmountsList: 'shared-expense-custom-amounts',
    customAmountInput: 'shared-expense-custom-amount-input',
    customAmountsTotal: 'shared-expense-custom-amounts-total',
    customAmountsError: 'shared-expense-custom-amounts-error',
    editButton: 'shared-expense-edit-button',
    deleteButton: 'shared-expense-delete-button',
    totalAmount: 'shared-expenses-total-amount',
    totalPerPerson: 'shared-expenses-total-per-person',
    balancesPanel: 'shared-expenses-balances-panel',
    balanceItem: 'shared-expenses-balance-item',
    settlementTransaction: 'shared-expenses-settlement-transaction',
    settledState: 'shared-expenses-settled-state',
};

export const CONFLICT_POLL = {
    resolveButton: 'conflict-resolve-button',
    pollCard: 'conflict-poll-card',
    pollOption: 'conflict-poll-option',
    pollOptionTally: 'conflict-poll-option-tally',
    pollResolved: 'conflict-poll-resolved',
    pollCancel: 'conflict-poll-cancel-button',
    votesTabSection: 'votes-tab-decisions-section',
};

export const UPGRADE = {
    modal: 'upgrade-modal',
    openButton: 'upgrade-open-button',
    closeButton: 'upgrade-close-button',
    payButton: 'upgrade-pay-button',
    featureItem: 'upgrade-feature-item',
    priceLabel: 'upgrade-price-label',
    premiumBadge: 'trip-premium-badge',
    paymentProcessing: 'payment-processing-overlay',
    modalCompareLink: 'upgrade-compare-link',
};

export const PREMIUM_PAGE = {
    container: 'premium-page',
    freeColumn: 'premium-free-column',
    premiumColumn: 'premium-premium-column',
    freeFeature: 'premium-free-feature',
    premiumFeature: 'premium-premium-feature',
    backHomeButton: 'premium-back-home-button',
    footerLink: 'footer-premium-link',
};
